import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSession, useOrder, useLanguage, useConfig, AddressForm as AddressFormController } from '~components'
import {
  Alert,
  Modal,
  AddressForm,
  AddressList
} from '~ui'
import { GoogleGpsButtonHome } from '../GoogleGpsButtonHome'
import MdLocationOn from '@meronex/icons/md/MdLocationOn'
import BiSearchAlt2 from '@meronex/icons/bi/BiSearchAlt2'
import CgSearchLoading from '@meronex/icons/cg/CgSearchLoading'
import GiWineGlass from '@meronex/icons/gi/GiWineGlass'
import GiStrawberry from '@meronex/icons/gi/GiStrawberry'

import {
  CategoriesContainer,
  MainSection,
  ContentGrid,
  LeftCol,
  RightCol,
  MainTitle,
  SearchWrap,
  SearchInput,
  SearchIconBtn,
  CategoryGrid,
  CategoryButton,
  BottomBar,
  BottomText,
  BottomBtn
} from './styles'

export const CategoriesHeroUI = (props) => {
  const { onFindBusiness, updateChanges, formState, saveAddress } = props

  const history = useHistory()
  const [{ auth }] = useSession()
  const [orderState] = useOrder()
  const [, t] = useLanguage()
  const [modals, setModals] = useState({ listOpen: false, formOpen: false })
  const [configState] = useConfig()
  const userCustomer = parseInt(window.localStorage.getItem('user-customer'))
  const [isGPSAddress, setIsGPSAddress] = useState(false)
  const maxLimitLocation = configState?.configs?.meters_to_change_address?.value
  const googleMapsApiKey = configState?.configs?.google_maps_api_key?.value
  const [alertState, setAlertState] = useState({ open: false, content: [] })
  const [shouldFindBusiness, setShouldFindBusiness] = useState(false)

  const mapErrors = {
    ERROR_NOT_FOUND_ADDRESS: 'Sorry, we couldn\'t find an address',
    ERROR_MAX_LIMIT_LOCATION: `Sorry, You can only set the position to ${maxLimitLocation}m`
  }

  const setMapErrors = (errKey) => {
    setAlertState({
      open: true,
      content: !(errKey === 'ERROR_MAX_LIMIT_LOCATION')
        ? [t(errKey, mapErrors[errKey])]
        : `${[t(errKey, mapErrors[errKey])]} ${maxLimitLocation} ${[t('METTERS', 'meters')]}`
    })
  }

  const closeAlert = () => {
    setAlertState({
      open: false,
      content: []
    })
  }

  const handleFindBusinesses = () => {
    if (!orderState?.options?.address?.location) {
      setModals({ ...modals, formOpen: true })
      return
    }
    window.sessionStorage.setItem('force_enter_first_business', 'true')
    setModals({ listOpen: false, formOpen: false })
    onFindBusiness && onFindBusiness()
  }

  const handleAddressInput = () => {
    if (auth) {
      setModals({ ...modals, listOpen: true })
    } else {
      setModals({ ...modals, formOpen: true })
    }
  }

  const handleGpsGeocode = (location) => {
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ location }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        const addressObj = {}
        for (const component of results[0].address_components) {
          const addressType = component.types[0]
          if (addressType === 'locality') addressObj.city = component.long_name
          if (addressType === 'country') addressObj.country = component.long_name
          if (addressType === 'administrative_area_level_1') addressObj.state = component.long_name
        }
        const address = {
          address: results[0].formatted_address,
          location,
          utc_offset: (new Date()).getTimezoneOffset(),
          map_data: {
            library: 'google',
            place_id: results[0].place_id
          },
          ...addressObj
        }
        updateChanges(address)
      } else {
        setMapErrors('ERROR_NOT_FOUND_ADDRESS')
      }
    })
  }

  useEffect(() => {
    if (formState?.changes?.address) {
      saveAddress()
    }
  }, [formState?.changes?.address])

  useEffect(() => {
    if (shouldFindBusiness && orderState?.options?.address?.location) {
      handleFindBusinesses()
      setShouldFindBusiness(false)
    }
  }, [orderState?.options?.address?.location, shouldFindBusiness])

  const categories = [
    { name: 'VODKA', color: 'pink', action: handleFindBusinesses },
    { name: 'TEQUILE / RUM', color: 'cyan', action: handleFindBusinesses },
    { name: '', color: 'cyan', icon: <GiWineGlass />, iconColor: 'white', action: handleFindBusinesses },
    { name: 'WHISKY / BEER', color: 'pink', action: handleFindBusinesses },
    { name: '', color: 'pink', icon: <GiStrawberry />, iconColor: '#fc0a7e', action: handleFindBusinesses },
    { name: 'WINE COOLERS', color: 'cyan', action: handleFindBusinesses },
    { name: 'VAPES', color: 'cyan', action: () => history.push('/pages/vapes') },
    { name: 'PICKUP & MORE', color: 'pink', action: handleFindBusinesses }
  ]

  return (
    <CategoriesContainer>
      <MainSection>
        <ContentGrid>
          <LeftCol>
            <MainTitle>{t('ENTER_YOUR_LOCATION_TO_VIEW_MENU', 'ENTER YOUR LOCATION TO VIEW MENU')}</MainTitle>

            <SearchWrap onClick={handleAddressInput}>
              <SearchInput
                placeholder={t('SEARCH_BY_ADDRESS_OR_POSTAL_CODE', 'Search by address or postal code')}
                readOnly
                value={orderState?.options?.address?.address || ''}
              />
              <SearchIconBtn><BiSearchAlt2 /></SearchIconBtn>
            </SearchWrap>

            <GoogleGpsButtonHome
              className='gps-button'
              apiKey={googleMapsApiKey}
              isGetAddress={false}
              onData={(e) => {
                handleGpsGeocode(e.location)
              }}
              onError={setMapErrors}
              IconButton={MdLocationOn}
              IconLoadingButton={CgSearchLoading}
              isUseLocationText
            />
          </LeftCol>

          <RightCol>
            <CategoryGrid>
              {categories.map((cat, i) => (
                <CategoryButton key={i} color={cat.color} iconColor={cat.iconColor} onClick={cat.action}>
                  {cat.icon ? cat.icon : t(cat.name.replace(/ /g, '_').replace(/\//g, ''), cat.name)}
                </CategoryButton>
              ))}
            </CategoryGrid>
          </RightCol>
        </ContentGrid>
      </MainSection>

      <BottomBar>
        <BottomText>{t('PLACE_AN_ORDER_FOR_DELIVERY', 'PLACE AN ORDER FOR DELIVERY')}</BottomText>
        <BottomBtn onClick={handleFindBusinesses}>{t('START_ORDER', 'START ORDER')}</BottomBtn>
      </BottomBar>

      {modals.formOpen && (
        <Modal
          title={t('WHERE_DO_WE_DELIVERY', 'Where do we delivery?')}
          open={modals.formOpen}
          onClose={() => setModals({ ...modals, formOpen: false })}
        >
          <AddressForm
            useValidationFileds
            address={orderState?.options?.address || {}}
            isGetAddress={isGPSAddress}
            onClose={() => { setModals({ ...modals, formOpen: false }); setIsGPSAddress(false) }}
            onSaveAddress={() => { setModals({ ...modals, formOpen: false }); setIsGPSAddress(false); setShouldFindBusiness(true); handleFindBusinesses() }}
            onCancel={() => setModals({ ...modals, formOpen: false })}
          />
        </Modal>
      )}

      {modals.listOpen && (
        <Modal
          title={t('WHERE_DO_WE_DELIVERY', 'Where do we delivery?')}
          open={modals.listOpen}
          width='70%'
          onClose={() => setModals({ ...modals, listOpen: false })}
        >
          <AddressList
            isModal
            changeOrderAddressWithDefault
            userId={isNaN(userCustomer) ? null : userCustomer}
            onCancel={() => setModals({ ...modals, listOpen: false })}
            onAccept={() => { setModals({ ...modals, listOpen: false }); handleFindBusinesses() }}
          />
        </Modal>
      )}

      <Alert
        title={t('ADDRESS', 'Address')}
        content={alertState.content}
        acceptText={t('ACCEPT', 'Accept')}
        open={alertState.open}
        onClose={() => closeAlert()}
        onAccept={() => closeAlert()}
      />
    </CategoriesContainer>
  )
}

export const CategoriesHero = (props) => {
  const homeHeroProps = {
    ...props,
    UIComponent: CategoriesHeroUI,
    isSelectedAfterAdd: true
  }

  return <AddressFormController {...homeHeroProps} />
}
